"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ExceptionalRefuge() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="187600" id="lart-de-recevoir-à-nice" className="relative w-full bg-background py-32 md:py-48 lg:py-56 overflow-hidden flex items-center justify-center dark">
            {}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[12rem] md:text-[20rem] lg:text-[28rem] font-serif italic text-accent/[0.03] pointer-events-none select-none whitespace-nowrap z-0" aria-hidden="true">
                Nice
            </div>

            <div ref={ref} className={`relative z-10 w-full max-w-4xl mx-auto px-6 md:px-12 text-center flex flex-col items-center gap-8 md:gap-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <span className="text-accent text-xs md:text-sm font-default font-semibold tracking-[0.2em] uppercase">
                    L'Art de Recevoir à Nice
                </span>

                <h2 className="text-4xl md:text-5xl lg:text-6xl font-default text-foreground leading-tight">
                    L'Art de Recevoir
                </h2>

                <p className="text-lg md:text-xl text-muted-foreground font-default font-light leading-relaxed max-w-2xl mx-auto">
                    Au cœur de la Côte d'Azur, <strong className="font-medium text-foreground">D location</strong> redéfinit les standards de la conciergerie. Nous allions réactivité, transparence et excellence pour sublimer votre patrimoine et offrir à vos voyageurs une expérience sur-mesure d'exception.
                </p>

                <div className="pt-8 md:pt-12">
                    <Button asChild variant="outline" className="rounded-none border-accent/30 text-foreground hover:bg-accent hover:text-accent-foreground transition-all duration-300 px-8 py-6 text-sm tracking-[0.15em] uppercase h-auto">
                        <Link to="#">Découvrir nos services</Link>
                    </Button>
                </div>
            </div>
        </section>;
}